import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'demo-upp-button-bar',
    templateUrl: './demo-upp-button-bar.html',
    styleUrls: ['../demo-common.scss', './demo-upp-button-bar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppButtonBarComponent {
    active = 'day';
    disabled = false;

    constructor(private change: ChangeDetectorRef) {
    }

    onSelect(value: string): void {
        this.active = value;
        this.change.markForCheck();
    }

    toggleDisabled(): void {
        this.disabled = !this.disabled;
        this.change.markForCheck();
    }
}
